module.exports = __webpack_public_path__ + "img/myreview_empty.3c6d8bc7.jpg";